import { render, staticRenderFns } from "./editarPerfil.vue?vue&type=template&id=2d8ad136&scoped=true"
import script from "./editarPerfil.vue?vue&type=script&lang=js"
export * from "./editarPerfil.vue?vue&type=script&lang=js"
import style0 from "./editarPerfil.vue?vue&type=style&index=0&id=2d8ad136&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8ad136",
  null
  
)

export default component.exports